<ng-container *ngIf="plansData && planOptionSelectorId">
  <tmo-page-titles
    [pageTitle]="configurableAEMContent?.pageTitlePrimaryMessage"
    [heading]="configurableAEMContent?.pageTitleSecondaryMessage"
  >
  </tmo-page-titles>
  <div class="m-t-lg">
    <tmo-container-holder
      [isDynamicContent]="prePurchasedPlanAuthorableContent"
    ></tmo-container-holder>
  </div>
  <div>
    <form [formGroup]="simValidationForm">
      <div class="row m-t-md">
        <div class="col-12 col-md-5 col-lg-4">
          <tmo-input
            type="text"
            [id]="'pre_purchased_plan_sim_input'"
            formControlName="simNumber"
            [aria-label]="configurableAEMContent?.enterSimNumber"
            [fieldType]="fieldValidationConstants?.SIM"
            [isInputDirty]="
              !simValidationForm?.controls?.simNumber?.valid &&
              simValidationForm?.controls?.simNumber?.touched
            "
            placeholder="SIM card number"
          >
          </tmo-input>
        </div>
      </div>
      <div class="m-t-sm icon-margin" *ngIf="simValidationMessage?.getMessage()">
        <i
          class="fa def active m-r-sm"
          [ngClass]="simValidationMessage?.getSuccess() ? 'fa-check' : 'fa-flag'"
        ></i
        >{{ simValidationMessage?.getMessage() }}
      </div>
    </form>
    <div class="row" *ngIf="error">
      <div class="col-12 m-t-md">
        <tmo-error-message-detail [errorMessage]="error"></tmo-error-message-detail>
      </div>
    </div>
    <h4 class="m-t-xl">{{ configurableAEMContent?.reviewYourPlan }}</h4>
    <div *ngIf="plansData?.familyPlans[0]?.planOptions?.length > 0">
      <p class="lead bold alert-text m-t-lg">
        <i class="fa fa-check alert-icon def"></i>
        {{ plansData?.familyPlans[0]?.planOptions[0]?.label }}
      </p>
      <p class="alert-text">{{ plansData?.familyPlans[0]?.planOptions[0]?.shortDescription }}</p>
      <p class="m-t-sm alert-text">
        <a
          href="javascript:void(0)"
          class="small"
          (click)="showSeeMoreModal($event)"
          id="cta-default-224"
          >{{ configurableAEMContent?.seeMore }}</a
        >
      </p>
      <p class="alert-text xsmall m-t-lg">
        {{ plansData?.familyPlans[0]?.planOptions[0]?.alternateDescriptions[0].text }}
      </p>
      <tmo-dynamic-modal [modal]="modal" (onHide)="closeModal()">
        <ng-container header>
          <div class="modal-logo-close">
            <i class="logo-icon t-icon t-icon-logo"></i>
            <a
              tabindex="0"
              [attr.aria-label]="aemContent?.clickToClose"
              href="javascript:void(0)"
              class="close-x pull-right"
              (click)="closeModal()"
              id="cta-click-to-close-8"
            >
              <i class="fa fa-times"></i>
            </a>
          </div>
          <div class="row">
            <div class="col-8">
              <h3>{{ plansData?.familyPlans[0]?.planOptions[0]?.label }}</h3>
            </div>
            <div class="col-4 m-t-lg text-end">
              <p tabindex="-1" aria-label="" aria-hidden="true" class="lead">
                {{
                  plansData?.familyPlans[0]?.planOptions[0]?.monthlyPrice?.displayValue
                    | currency: 'USD' : 'symbol'
                }}
              </p>
              <p tabindex="-1" aria-label="" aria-hidden="true" class="xsmall">
                {{ configurableAEMContent?.perMonth }}
              </p>
            </div>
            <div class="col-12 m-t-sm" *ngIf="isAssistedFlow">
              <p class="small">
                ({{ configurableAEMContent?.offerCode }}: {{ selectedPlanName?.attribute }})
              </p>
            </div>
          </div>
        </ng-container>
        <p class="lead bold">{{ configurableAEMContent?.planDescription }}</p>
        <p class="small m-t-sm">{{ plansData?.familyPlans[0]?.planOptions[0]?.longDescription }}</p>
        <p class="xsmall m-t-lg" *ngIf="selectedPlanName?.alternateDescriptions?.length">
          {{ plansData?.familyPlans[0]?.planOptions[0]?.alternateDescriptions[0]?.text }}
        </p>
        <ng-container footer> </ng-container>
      </tmo-dynamic-modal>
    </div>
    <div class="m-t-lg">
      <tmo-error-message-detail
        *ngIf="!plansData"
        [errorMessage]="error"
      ></tmo-error-message-detail>
    </div>
    <div *ngIf="!isTourist">
      <h4 class="m-t-xl">{{ configurableAEMContent?.addYourServices }}</h4>
      <p class="alert-text m-t-lg">
        <i class="fa fa-flag def alert-icon"></i>
        {{ configurableAEMContent?.servicesOptionalMessage }}
      </p>
      <tmo-service-section
        *ngIf="cartData"
        [softGoodsAEMContent]="configurableAEMContent"
        [isPrePurchasedPlan]="true"
      ></tmo-service-section>
    </div>
    <h4 class="m-t-xl">{{ configurableAEMContent?.getReadyToActivate }}</h4>
    <p class="m-t-lg lead">{{ configurableAEMContent?.stepTwoMessage }}</p>
    <div class="row m-b-xl">
      <div class="col-12 buttons-container button-spacing-legal">
        <div class="button-box">
          <tmo-button
            [button]="continue"
            [disabled]="!simValidationForm?.valid && !validSIMNumber"
            (onSelect)="goToCartReviewScreen()"
            id="tmo-button-continue-5"
            >{{ configurableAEMContent?.continue }}
          </tmo-button>
        </div>
      </div>
    </div>
    <tmo-container-holder [isDynamicContent]="legalTextAuthorableContent"></tmo-container-holder>
  </div>
</ng-container>
<ng-container>
  <tmo-spinner [setDelay]="!showSpinner"></tmo-spinner>
</ng-container>
